/*global mdui */

require('promise.prototype.finally').shim();


import {
    IEGoto,
    imgPreload,
} from "@/utils/browserHandle";

// config 里面的 myFn 也有
window.$md = mdui ? mdui.JQ : {};


IEGoto();


// imgPreload();
